export const getErrorMessage = (error) => {
  if (typeof error === 'object' && 'data' in error && 'errorMessage' in error.data) {
    return error.data.errorMessage
  }

  return error.defaultMessage || error
}
